import React, { useEffect, useState, useRef } from 'react';
import LoggedInLayout from 'layouts/LoggedInLayout';
import useLeftMenu from 'hooks/useLeftMenu';
import { MENUS } from 'configs/page';
import { useParams } from 'react-router';
import useCampaigns from 'hooks/useCampaigns';
import useCampaignsSummary from 'hooks/useCampaignsSummary';
import useCampaignDetail from 'hooks/useCampaignDetail';
import useLookup from 'hooks/useLookup';
import useToast from 'hooks/useToast';
import { PAGE_NAV } from 'configs/page';
import ConfirmPopup from 'components/modals/ConfirmPopup';
import AddPromoCodePopup from 'components/modals/AddPromoCodePopup';
import { useSetRecoilState  } from 'recoil';
import { dashboardCampaignSelectionAtom } from 'recoil/stats/dashboardFilters';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faCopy, faSync, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import ButtonWithSpinner from '../components/buttons/ButtonSpinner';
import useModalDisplay from 'hooks/useDisplayModal';
import EditCampaignNamePopup from 'components/modals/EditCampaignNamePopup';
import UpdatePromoCodeNamePopup from 'components/modals/UpdatePromoCodeNamePopup';

import trashLineIco from '../assets/img/btn-ico/trash-ico-line-red.svg';
import penLineIco from '../assets/img/btn-ico/pen-ico-line.svg';
import copyLineIco from '../assets/img/btn-ico/copy-ico-line.svg';

function matchCampaignUrl(url) {
  const regex = /^https?:\/\/[^/]+(?:\/Redir)?\/([ce]-\d+)(?:\?.*)?$/i;
  const match = url.match(regex);

  if (!match) {
    return null;
  }

  return {
    matched: true,
    code: match[1],          // e.g. "c-1406" or "e-1406"
    type: match[1][0],       // "c" or "e"
    id: match[1].slice(2),   // "1406"
  };
}

const validationSchema = Yup.object().shape({
        title: Yup.string().trim().required("Campaign name is required"),
        
    });

const CampaignDetails = (props) => {
    const { history } = props;
    const {open, handleOpen, handleClose} = useModalDisplay();
    const {open:openPromo, handleOpen:handleOpenPromo, handleClose:handleClosePromo} = useModalDisplay();
    const setSelCampaignID = useSetRecoilState(dashboardCampaignSelectionAtom);
    const toast = useToast();
    const lookupProvider = useLookup();
    const [leftMenu, setLeftMenu] = useLeftMenu();
    let { campaignID: campaignDetailID } = useParams();
    const { dateRangeID, setDateRangeID, deleteCampaign, addPromoCode, 
        extendPromoCode, updateCampaignName } = useCampaigns();
    const { statDates } = lookupProvider;

    const campaignID = parseInt(campaignDetailID);
    const { data: campaignSummary } = useCampaignsSummary(dateRangeID);
    const { data: campaignDetail } = useCampaignDetail(campaignID, dateRangeID);

    const CampaignDetail = campaignDetail?.CampaignDetail ?? null;
    const PromoCode = CampaignDetail?.PromoCode ?? null;
    const Code = PromoCode?.Code ?? '';
    let Url = "";
    
    if(matchCampaignUrl(CampaignDetail?.LandingPage ?? '')){
        Url = CampaignDetail?.LandingPage;
    }
    else {
        Url = PromoCode?.Url ?? (CampaignDetail?.LandingPage ?? '');
    }
  
    const daysLeft = PromoCode ? moment(PromoCode.DateExpiry).diff(moment(), "days") : 0;

    const [dateSelDropdownOn, setDateSelDropdownOn] = useState(false);
    const [selectedDate, setSelectedDate] = useState("");
    const [ddlSelCampaign, setDdlSelCampaign] = useState(false);
    const [selectedCampaign, setSelectedCampaign] = useState("");
    const [showAddPomoCodePopup, setShowAddPromoCodePopup] = useState(false);
    const [delConfirmPopup, setDelConfirmPopup] = useState(false);
    const mountedRef = useRef(true);

    const {
            handleSubmit,
            setValue,
            trigger,
            clearErrors,
            formState: { errors },
            register,
        } = useForm({
            mode: "onSubmit",         
            reValidateMode: "onSubmit",
            defaultValues: { title: CampaignDetail?.Title?? '' },
            resolver: yupResolver(validationSchema),
        });

    

    useEffect(() => {
        return () => { mountedRef.current = false; };
    }, []);

    useEffect(() => {
        if (leftMenu.value !== "CAMPAIGNS")
            mountedRef.current && setLeftMenu(MENUS.find(menu => menu.value === "CAMPAIGNS"));
    }, [leftMenu, setLeftMenu]);

    useEffect(() => {
        if (!selectedDate && statDates.length > 0) {
            const selDate = statDates.find(dt => dt.ItemID === dateRangeID);
            if (selDate) setSelectedDate(selDate.ItemName);
        }
    }, [selectedDate, statDates, dateRangeID]);

    useEffect(() => {
        if (campaignSummary?.StatsSummaries?.length > 0) {
            const match = campaignSummary.StatsSummaries
                .find(dt => dt.CampaignDetail.CampaignID === campaignID);
            if (match && match.CampaignDetail.Title !== selectedCampaign)
                setSelectedCampaign(match.CampaignDetail.Title);
        }
    }, [campaignSummary, campaignID, selectedCampaign]);

    useEffect(() => {
        if (!campaignDetailID || isNaN(campaignDetailID)) {
            history.push(PAGE_NAV.CAMPAIGNS);
            return;
        }
        if (campaignSummary?.StatsSummaries?.length > 0) {
            const exists = campaignSummary.StatsSummaries
                .find(dt => dt.CampaignDetail.CampaignID === campaignID);
            if (!exists) history.push(PAGE_NAV.CAMPAIGNS);
        }
    }, [campaignSummary, campaignDetailID, campaignID, history]);

    const updateSelDate = (date, e) => {
        e.preventDefault();
        setDateRangeID(date.ItemID);
        setSelectedDate(date.ItemName);
        setDateSelDropdownOn(false);
    };

    const updateSelectedCampaign = (campaign, e) => {
        e.preventDefault();
        setDdlSelCampaign(false);
        history.push(`${PAGE_NAV.CAMPAIGNS}/${campaign.CampaignDetail.CampaignID}`);
    };

    const onSubmitHandler = async (frmData, e) => {
        //console.log("here")
        e.preventDefault();
        if (updateCampaignName.isLoading) return;
        if (!campaignDetailID || isNaN(campaignDetailID) || campaignID < 1) return;
        updateCampaignName.mutateAsync({ 
                id: campaignDetailID,
                title: frmData.title, 
            })
            .then(()=>{ setEditTitleMode(false); })
            .catch(err => toast.error("Failed to add new campaign", err));
    };

    const extendPromoCodeClicked = (e)=>{
        e.preventDefault();
        if(extendPromoCode.isLoading) return;
        if (!campaignDetailID || isNaN(campaignDetailID) || campaignID < 1) return;

        extendPromoCode.mutateAsync({id:campaignDetailID})
            .catch(err => toast.error("Failed to refresh promo code", err));
    }

    const onDeleteConfirmed = () => {
        if (deleteCampaign.isLoading) return;
        if (!campaignDetailID || isNaN(campaignDetailID) || campaignID < 1) return;

        deleteCampaign.mutateAsync(campaignDetailID)
            .then(() => {
                setSelCampaignID(0);
                if (mountedRef.current) {
                    setDelConfirmPopup(false);
                    history.push(PAGE_NAV.DASHBOARD);
                }
            })
            .catch(err => toast.error("Failed to remove campaign", err));
    };

    const copyLink = useRef(null);
    const copyLinkToClipboard = () => {
        copyLink.current.select();
        document.execCommand('copy');
    };

    const copyPromoCodeLink = useRef(null);
    const copyPromoCodeLinkToClipboard = () => {
        copyPromoCodeLink.current.select();
        document.execCommand('copy');
    };

    const [campaignName, setCampaignName] = useState(CampaignDetail && CampaignDetail.Title ?
                                     CampaignDetail.Title : '');
    const [editTitleMode, setEditTitleMode] = useState(false);                            


    useEffect(()=>{
        setCampaignName(CampaignDetail?.Title?? '');
        setValue('title', CampaignDetail?.Title?? '')
    }, [CampaignDetail, CampaignDetail?.Title])

    // useEffect(()=>{
    //     console.log("errors", errors)
    // }, [errors])

    return (
        <div onClick={() => { setDdlSelCampaign(false); setDateSelDropdownOn(false); }}>
        <LoggedInLayout {...props} 
        /*subPageTitle={<span className='pill'>Affiliate ID: <span className='val'>RHP{campaignDetailID}</span></span>}*/ 
        >
        {/* <div className='mobile-page-header'>
                    <h1>Campaigns</h1>
        </div> */}
        <div className='card-group campaign-name-group'>
            <div className='card'>
                <div className='card-header'>
                    <h3 style={{margin: "15px 0 10px"}}>Campaign name</h3>
                </div>
                <div className='card-content'>
                        <div className="link-field input-field btn-field">
                            <input className='grey none-outline'
                                type="text" readOnly={true}
                                value={
                                    CampaignDetail && CampaignDetail.Title ?
                                     CampaignDetail.Title : ''
                                    } />
                            <p className="btn">
                                <button className='ico-btn none-outline' onClick={(e)=>{e.preventDefault(); e.currentTarget.blur(); handleOpen();}}>
                                {/* <FontAwesomeIcon icon={faPen} /> */}
                                <img src={penLineIco} style={{width: "18px"}} className='btn-ico' />
                                </button>
                            </p>
                        </div>
                        <p className='pill'>Affiliate ID: <span className='val'>RHP{campaignDetailID}</span></p>
                </div>
            </div>
        </div>

        
        <div className='card-group link-promo-group'>
            <div className='card-group generated-link-group'>
                <div className='card'>
                    <div className='card-header'>
                        <div>
                            <h3 style={{margin: "15px 0 10px"}}>Generated link</h3>
                        </div>
                    </div>
                    {
                        Url &&
                        <div className='card-content'>
                            <div className="link-field input-field btn-field">
                                <input className='grey none-outline' ref={copyPromoCodeLink}
                                    type="text" readOnly={true}
                                    value={Url} />
                                <p className="btn">
                                    <button className='ico-btn none-outline' onClick={copyPromoCodeLinkToClipboard}>
                                    <img src={copyLineIco} style={{width: "22px"}} className='btn-ico' />
                                    </button>
                                </p>
                            </div>
                        </div>

                    }
                </div>
            </div>



             
            { 
                Code && 
                    <div className='card-group promo-code-group'>
                        <div className='card'>
                            <div className='card-header'>
                                <div>
                                    <h3 style={{margin: "15px 0 10px"}}>Promo code</h3>
                                </div>
                                    <p className='expires-date'><span style={{"textAlign": "right"}}><span>Expires in:</span> <span style={{"whiteSpace": "nowrap"}} className='val'>{daysLeft} {daysLeft == 1 ? 'day': 'days'}</span></span> 
                                    {/* <span className="btn round grey light  refresh-btn"><button onClick={extendPromoCodeClicked}><FontAwesomeIcon icon={faSync} /> <span className='label'></span></button></span> */}
                                    </p> 
                            </div>

                            <div className='card-content'>

                                {/* <div>

                                    {
                                        Code && <p className='expires-date'><span style={{"textAlign": "right"}}><span>Promo code expires in:</span> <span style={{"marginLeft":"5px", "whiteSpace": "nowrap"}} className='val'>{daysLeft} {daysLeft == 1 ? 'day': 'days'}</span></span> </p> 
                                    }

                                    {
                                            CampaignDetail &&
                                            <>
                                                {Code && 
                                                <p className='active-promo sub' style={{display: "flex", alignItems:"center", flexWrap:"wrap"}} ><span>Active promo code:</span> <strong style={{"marginLeft":"5px"}}>{Code}</strong>
                                                <span className="btn promo-btn"><button style={{backgroundColor:"transparent"}} className='ico-btn none-outline' onClick={(e)=>{e.preventDefault(); e.currentTarget.blur(); handleOpenPromo()}}>
                                                    <img src={penLineIco} style={{width: "18px"}} className='btn-ico' />
                                                </button></span>
                                                </p>}
                                                <AddPromoCodePopup
                                                    open={showAddPomoCodePopup}
                                                    close={() => setShowAddPromoCodePopup(false)}
                                                    mountedRef={mountedRef}
                                                    campaignDetailID={campaignDetailID}
                                                    addPromoCode={addPromoCode}
                                                />   
                                            </>
                                    }                      
                                </div> */}
                                
                                <div>
                                    {
                                        CampaignDetail &&
                                        <div className="promo-code-field input-field btn-field">
                                            <input className='grey none-outline' ref={copyPromoCodeLink}
                                                type="text" readOnly={true}
                                                value={Code} />
                                            <p className="btn">
                                                <button style={{backgroundColor:"transparent"}} className='ico-btn none-outline' onClick={(e)=>{e.preventDefault(); e.currentTarget.blur(); handleOpenPromo()}}>
                                                {/* <FontAwesomeIcon icon={faPen} /> */}
                                                <img src={penLineIco} style={{width: "18px"}} className='btn-ico' />
                                                </button>
                                                <AddPromoCodePopup
                                                            open={showAddPomoCodePopup}
                                                            close={() => setShowAddPromoCodePopup(false)}
                                                            mountedRef={mountedRef}
                                                            campaignDetailID={campaignDetailID}
                                                            addPromoCode={addPromoCode}
                                                        /> 
                                            </p>
                                        </div>
                                    }
                                    

                                    
                                </div>
                                
                            </div>
                            
                        </div>
                    </div>
            }




        </div>




        <div className='card-group delete-campaign'>
            <div className='card'>
                <div className='card-header'></div>
                <div className='card-content'>
                    <div>
                        <h3 style={{margin: "0 0 10px"}}>Delete campaign</h3>
                        <p>This permanently removes the campaign, its link and promo code.</p>
                    </div>
                    
                    <p className="btn round red light del"><button className='ico-btn none-outline' onClick={(e) => { e.preventDefault(); setDelConfirmPopup(true); }}>{/*<FontAwesomeIcon icon={faTrashAlt} />*/}<img src={trashLineIco} style={{width: "18px"}} className='btn-ico' /> <span className='label'>Delete campaign</span></button></p>
                </div>
            </div>
        </div>

        <ConfirmPopup
            open={delConfirmPopup}
            close={() => setDelConfirmPopup(false)}
            confirm={onDeleteConfirmed}
            heading="Delete campaign"
            btnText="Delete campaign">
                <p>Are you sure you want to delete this campaign: {selectedCampaign}?</p>
        </ConfirmPopup>
        {
            open &&
            <EditCampaignNamePopup 
                campaignDetailID={campaignDetailID}
                open={open} 
                close={handleClose}
            />
        }
        {
            openPromo &&
            <UpdatePromoCodeNamePopup 
                campaignDetailID={campaignDetailID}
                open={openPromo} 
                close={handleClosePromo}
            />
        }

       
        </LoggedInLayout>
        </div>
    );
};

export default CampaignDetails;
